export const MAX_TIMEOUT_IN_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

export const WAYPOINT_DATE_DAY_FORMAT = 'dd.MM.yyyy'
export const WAYPOINT_DATE_FORMAT = `${WAYPOINT_DATE_DAY_FORMAT} HH:mm`

/**
 * A naive datetime with no offset - the digits the user typed, which the backend pairs with the
 * address's own zone. Sending an offset instead stores a Lisbon 08:00 pickup as 07:00.
 */
export const WALL_CLOCK_MODEL = 'yyyy-MM-dd\'T\'HH:mm'

export const TENDER_DATE_FORMAT = 'dd.MM.yyyy'
export const TENDER_DEADLINE_FORMAT = `${TENDER_DATE_FORMAT} HH:mm`

export const CARRIER_PORTAL_EMAIL = 'carrierPortalEmail'
export const CARRIER_PORTAL_TOKEN = 'carrierPortalToken'

export const MAX_BIDS = 3
